export default "/fonts/iconfont.eot?6a1ffd9b8be4141c00221a5266d7523a";